import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

export const PickerGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${primitive.$spacing1};

  ${Styles.desktop} {
    gap: 0;
  }

  li > *:first-child {
    padding-inline-start: 0;
    margin-inline-start: ${primitive.$spacing4};
    border-block-end: ${p => p.theme.token('border-default')};
  }
  li:last-of-type > *:first-child {
    border-block-end: none;
  }
`;
